import styled from 'styled-components';

export default styled.div`
	--trigger-size: 3.4rem;
	padding: 0 0 0 calc(var(--trigger-size) / 2);
	.team-accordion-header {
		position: relative;
		& > .motif-icon {
			position: absolute;
			top: 50%;
			left: -0.5rem;
			transform: translateY(-50%);
			width: var(--px-16);
			height: var(--px-16);
			svg {
				width: var(--px-16) !important;
				height: var(--px-16) !important;
			}
		}
	}
	.team-accordion-content {
		display: ${({open}) => (open ? 'block' : 'none')};
		transition: height 1s ease-in-out;
	}
`;
